import React from "react";
import { Overlay, Popover } from "react-bootstrap";
import { HoverCardHeader, HoverCardHeaderProps } from "./HoverCardHeader";
import { HoverCardListItem, HoverCardListItemProps } from "./HoverCardListItem";
import { OverlayProps } from "@restart/ui/Overlay";
import cn from "classnames";

export const HoverCard: React.FC<{
    target: HTMLTableRowElement | null;
    fixedArrow?: boolean;
    header: HoverCardHeaderProps;
    list: HoverCardListItemProps[];
    popperConfig?: OverlayProps["popperConfig"];
}> = ({ target, fixedArrow = true, header, list, popperConfig }) => (
    <Overlay show target={target} placement="bottom" flip popperConfig={popperConfig}>
        {(props) => (
            <Popover className={cn("fs-6", { "fixed-arrow": fixedArrow })} {...props} style={{ ...props.style, minWidth: "18.75rem" }}>
                <Popover.Body className="px-2 py-0">
                    <div className="d-flex flex-column">
                        <HoverCardHeader {...header} />
                        <div className="d-grid row-gap-1" style={{ gridTemplateColumns: "auto 1fr" }}>
                            {list.map(({ label, value }) => (
                                <HoverCardListItem label={label} value={value} />
                            ))}
                        </div>
                    </div>
                </Popover.Body>
            </Popover>
        )}
    </Overlay>
);
